import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityRPERolActividadesState,
  entityRPERolActividadesAdapter
} from './entity-rpe-rol-actividades.state';
import {
  entityRPERolActividadesAddFailure,
  entityRPERolActividadesAddRequest,
  entityRPERolActividadesAddSuccess
} from './entity-rpe-rol-actividades.actions';

const reducer = createReducer(
  initialState,
  // add
  on(entityRPERolActividadesAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityRPERolActividadesAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityRPERolActividadesAddSuccess, (state, { item }) =>
    entityRPERolActividadesAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function RPERolActividadesReducer(
  state: EntityRPERolActividadesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
